import styled from "styled-components";

export const InfoContainer = styled.div`
  position: relative;
  display: flex;
  margin-bottom: 0.5rem;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1rem;
  height: 1rem;
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
  transition: opacity 0.2s ease-in-out;

  &:hover {
    opacity: 0.8;
  }
`;

export const Tooltip = styled.div`
  position: absolute;
  top: -2rem;
  left: 2rem;
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.secondary};
  box-shadow: ${({ theme }) => theme.shadows.secondaryShadow};
  padding: 12px 16px;
  border-radius: 6px;
  z-index: 10;
  width: 300px;
  font-size: 1rem;
  line-height: 1.4;
  text-align: left;
  opacity: 0;
  visibility: hidden;
  transition:
    opacity 0.3s ease-in-out,
    visibility 0.3s ease-in-out;

  &::after {
    content: "";
    position: absolute;
    top: 2.5rem;
    left: -1.5rem;
    transform: translateY(-50%);
    border: 12px solid transparent;
    border-right-color: ${({ theme }) => theme.colors.white};
  }

  @media (max-width: 767px) {
    left: -8rem;
    top: -5.5rem;

    &::after {
      top: 4.2rem;
      left: 7.7rem;
      transform: rotate(-90deg);
    }
  }
`;

export const InfoWrapper = styled.div`
  &:hover ${Tooltip} {
    opacity: 1;
    visibility: visible;
  }
`;
